import StyledButton from "components/shared/StyledButton";
import { SmallBody } from "helpers/TypographyComponents";
import { useCompanySettings } from "hooks/useCompanySettings";
import { fetchInterforumFiles } from "store/automatedImportStore";
import { useAppDispatch } from "store/store";

const CONNECTED_INTERFORUM_COMPANIES = [{ companyId: 142, companyName: "Rosie and Wolfe" }];
// ACMEDIA coming soon

const InterforumFiles = () => {
    const { companyInfos } = useCompanySettings();
    const dispatch = useAppDispatch();
    const isConnectedToInterforum =
        CONNECTED_INTERFORUM_COMPANIES.some((company) => company.companyId === companyInfos?.id) || true;

    const handleInterforumFiles = () => {
        dispatch(fetchInterforumFiles());
    };

    return (
        <div className="interforum-files-container ">
            {isConnectedToInterforum ? (
                <div className="flex flex-col gap-2 max-w-max">
                    <StyledButton buttonType="primary" onClick={() => handleInterforumFiles()}>
                        Récupérer les fichiers via S3
                    </StyledButton>
                    <SmallBody>{`Les fichiers seront traités et uploadés dans S3.`}</SmallBody>
                </div>
            ) : (
                <SmallBody>{`Aucune connexion à Interforum n'a été trouvée pour cette entreprise.`}</SmallBody>
            )}
        </div>
    );
};

export default InterforumFiles;
